module.exports = __webpack_public_path__ + "img/clock-bg.901b36f.svg";